document.documentElement.classList.remove('no-js');

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const form = select.closest('[data-product-form]');
  if (!form || !option) return;

  const price = form.querySelector('[data-product-price]');
  const compare = form.querySelector('[data-product-compare]');
  const button = form.querySelector('[data-add-to-cart]');

  if (price && option.dataset.price) price.textContent = option.dataset.price;

  if (compare) {
    if (option.dataset.compareAt) {
      compare.textContent = option.dataset.compareAt;
      compare.hidden = false;
    } else {
      compare.hidden = true;
      compare.textContent = '';
    }
  }

  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
  }
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-product-zoom]');
  if (trigger) {
    const dialog = document.querySelector('[data-product-zoom-dialog]');
    const image = dialog && dialog.querySelector('[data-product-zoom-image]');
    if (!dialog || !image) return;

    image.src = trigger.dataset.zoomSrc || '';
    image.alt = trigger.dataset.zoomAlt || 'Product image';

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    return;
  }

  const closeButton = event.target.closest('[data-product-zoom-close]');
  if (closeButton) {
    const dialog = closeButton.closest('[data-product-zoom-dialog]');
    if (dialog) dialog.close();
  }
});

document.addEventListener('click', function (event) {
  const dialog = event.target.closest('[data-product-zoom-dialog]');
  if (!dialog || event.target !== dialog) return;
  dialog.close();
});

